import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

const apiUrl = '/gsb/spidash/dashboardQuery';

@Injectable()
export class DashboardQueryService {

  constructor(private http: HttpClient) { }

  runQuery(key: string, parameters: any) {
    const url = `${apiUrl}/data/${key}` ;
    return this.http.post<any>(url, parameters,{});
  }

  findByPageAndType(queryCategoryName: string, p: number, size: number): Observable<any> {
    const params = new HttpParams()
      .set('category', String(queryCategoryName)) .set('page', String(p)).set('pageSize', String(size));
    return this.http.get<any>(apiUrl, {params});
  }

  findByPage(p: number, size: number, queryCategoryName: string): Observable<any> {
    const params = new HttpParams()
      .set('category', String(queryCategoryName))
      .set('page', String(p))
      .set('pageSize', String(size));
    return this.http.get<any>(apiUrl, {params});
  }

  findAll(): Observable<any> {
    const url = `${apiUrl}/all`;
    return this.http.get<any>(url);
  }

  getById(id: number) {
    const url = `${apiUrl}/${id}`;
    return this.http.get<any>(url);
  }

  create(dashboardQuery: any) {
    return this.http.post<any>(apiUrl, dashboardQuery, httpOptions);
  }

  update(id: number, dashboardQuery: any) {
    const url = `${apiUrl}/${id}`;
    return this.http.put(url, dashboardQuery, httpOptions);
  }

  delete(id: number) {
    const url = `${apiUrl}/${id}`;
    return this.http.delete<any>(url, httpOptions);
  }

}
